import axios from "axios";

export const getSignedNonce = async (web3, account) => {
  const nonce = await axios.get(
    "crypto_auth/generate_nonce.php?address=" + account,
  );
  return await web3.eth.personal.sign(nonce.data, account);
};
